import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Home, Wrench, Image } from "lucide-react";
import SEO from "../components/seo/SEO";
import Navigation from "../components/landing/Navigation";

const LINKS = [
    { to: "/",            label: "Domov",      icon: Home   },
    { to: "/referencie",  label: "Referencie", icon: Image  },
    { to: "/technika",    label: "Technika",   icon: Wrench },
];

export default function NotFoundPage() {
    return (
        <div className="min-h-screen bg-nova-black text-white">
            <SEO title="404 — Stránka nenájdená" noIndex />

            <Navigation />

            {/* Content */}
            <div className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden pt-20">
                {/* Background glow */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-nova-cyan/5 rounded-full blur-[120px]" />
                    <div className="absolute inset-0 grid-bg opacity-15" />
                </div>

                {/* Decorative 404 watermark */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
                    <span className="font-heading font-black text-[22vw] text-white/[0.025] tracking-tighter leading-none">
                        404
                    </span>
                </div>

                <div className="relative text-center max-w-lg">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.55 }}
                    >
                        {/* Label */}
                        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-nova-cyan mb-6 flex items-center justify-center gap-2">
                            <span className="w-6 h-px bg-nova-cyan/50 inline-block" />
                            Chyba 404
                            <span className="w-6 h-px bg-nova-cyan/50 inline-block" />
                        </div>

                        {/* Heading */}
                        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-tight mb-4">
                            Stránka{" "}
                            <span className="text-nova-cyan">nenájdená</span>
                        </h1>

                        <p className="text-zinc-400 text-base leading-relaxed mb-10">
                            Táto stránka neexistuje alebo bola presunutá.<br />
                            Skúste sa vrátiť na hlavnú stránku.
                        </p>

                        {/* Primary CTA */}
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 h-12 px-8 bg-nova-cyan text-black font-semibold text-sm rounded-xl
                                       hover:saturate-125 transition-all hover:shadow-[0_0_28px_rgba(0,153,255,0.4)] mb-10"
                        >
                            <ArrowLeft className="w-4 h-4" />
                            Späť na hlavnú
                        </Link>

                        {/* Quick links */}
                        <div className="border-t border-white/8 pt-8">
                            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600 mb-4">
                                Alebo prejdite na
                            </p>
                            <div className="flex items-center justify-center gap-3 flex-wrap">
                                {LINKS.map(({ to, label, icon: Icon }) => (
                                    <Link
                                        key={to}
                                        to={to}
                                        className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg border border-white/10
                                                   text-zinc-400 text-sm hover:border-white/25 hover:text-white transition-all"
                                    >
                                        <Icon className="w-3.5 h-3.5" />
                                        {label}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}
